import * as React from 'react'

const Logo = () => {
  return (
    <svg width='93' height='36' viewBox='0 0 93 36' xmlns='http://www.w3.org/2000/svg'>
      <g id='Canvas' fill='none'>
        <g id='logo'>
          <path
            d='M 36.9515 18.9924C 36.9515 8.50371 28.685 0 18.4758 0C 8.27468 0 0 8.50371 0 18.9924C 0 25.9114 3.60087 31.9645 8.98184 35.281L 11.6073 29.8896C 8.13649 27.5697 5.84429 23.5588 5.84429 18.9924C 5.84429 11.8202 11.5016 6.00406 18.4839 6.00406C 25.4662 6.00406 31.1235 11.8202 31.1235 18.9924C 31.1235 23.5588 28.8313 27.5778 25.3605 29.8896L 27.986 35.281C 33.3507 31.9645 36.9515 25.9114 36.9515 18.9924Z'
            fill='#fff'
            id='Vector'
          />
          <path
            d='M 9.18505 14.5486L 16.5575 17.0074L 8.27468 0L 0 17.0074L 7.37243 14.5486L 8.12836 8.26682C 8.14462 8.10344 8.38847 8.10344 8.40473 8.26682L 9.18505 14.5486Z'
            transform='translate(10.201 18.993)'
            fill='#fff'
            id='Vector_2'
          />
          <path
            d='M 12.1394 0.812027C 11.0275 0.266811 9.83532 2.83211e-06 8.55146 2.83211e-06C 6.16714 2.83211e-06 4.14963 0.858422 2.48749 2.57527C 0.825342 4.29212 -1.74913e-07 6.36859 -1.74913e-07 8.82786C -1.74913e-07 11.2291 0.813879 13.294 2.4531 15.0224C 4.08086 16.7393 6.05251 17.5861 8.33366 17.5861C 10.6836 17.5861 12.6094 16.7045 14.134 14.9296C 14.8103 14.1408 15.2803 13.294 15.5669 12.3892C 15.8534 11.4031 16.0025 10.2779 16.0025 9.01346L 16.0025 8.45665L 9.23924 8.45665L 9.23924 10.8579L 13.3201 10.8579C 13.2055 12.0528 12.6667 13.0736 11.6923 13.932C 10.7294 14.7788 9.62899 15.208 8.4139 15.208C 6.98102 15.208 5.66276 14.6396 4.43621 13.5028C 3.12942 12.2848 2.47603 10.7303 2.47603 8.83946C 2.47603 7.0066 3.06064 5.48696 4.24134 4.26893C 5.41057 3.02769 6.86638 2.41287 8.59731 2.41287C 10.0302 2.41287 11.3026 2.92329 12.4145 3.95572L 14.0308 2.15766C 13.4118 1.58925 12.7699 1.13684 12.1394 0.812027Z'
            transform='translate(49.269 10.42)'
            fill='#fff'
            id='Vector_3'
          />
          <path
            d='M 5.50228 -2.83211e-06C 3.96622 -2.83211e-06 2.6709 0.545213 1.60483 1.62404C 0.538764 2.70288 -6.99651e-07 4.02532 -6.99651e-07 5.56816C -6.99651e-07 7.20381 0.527302 8.57265 1.57044 9.65148C 2.61358 10.7535 3.90891 11.2987 5.45643 11.2987C 7.0154 11.2987 8.33366 10.7651 9.41119 9.68628C 10.4773 8.60745 11.016 7.26182 11.016 5.66097C 11.016 4.07172 10.4887 2.73768 9.42265 1.64725C 8.34512 0.545215 7.03833 -2.83211e-06 5.50228 -2.83211e-06ZM 7.73758 8.15504C 7.17589 8.78146 6.43079 9.08307 5.50228 9.08307C 4.57377 9.08307 3.82867 8.76986 3.26698 8.14344C 2.71675 7.51702 2.44164 6.6818 2.44164 5.60297C 2.44164 4.60534 2.72821 3.79331 3.2899 3.1669C 3.85159 2.54048 4.59669 2.22726 5.50228 2.22726C 6.43079 2.22726 7.17589 2.54048 7.73758 3.1669C 8.29927 3.79331 8.57438 4.61694 8.57438 5.66097C 8.57438 6.705 8.29927 7.52862 7.73758 8.15504Z'
            transform='translate(66.67 16.708)'
            fill='#fff'
            id='Vector_4'
          />
          <path
            d='M 8.02415 1.17164C 7.34783 0.394413 6.41932 -2.83211e-06 5.2157 -2.83211e-06C 4.17256 -2.83211e-06 3.23259 0.429214 2.39578 1.28764L 2.39578 -2.83211e-06L 0 -2.83211e-06L 0 11.2871L 2.39578 11.2871L 2.39578 5.82337C 2.39578 4.48933 2.55627 3.56131 2.8887 3.02769C 3.22113 2.48247 3.78282 2.21567 4.57377 2.21567C 5.3074 2.21567 5.80032 2.42447 6.07543 2.83048C 6.36201 3.2365 6.49957 3.95571 6.49957 5.01135L 6.49957 11.2871L 8.89535 11.2871L 8.89535 4.43133C 8.89535 2.92328 8.59731 1.83286 8.02415 1.17164Z'
            transform='translate(84.105 16.708)'
            fill='#fff'
            id='Vector_5'
          />
          <path
            d='M 2.38432 -2.83211e-06L 0 -2.83211e-06L 0 11.2871L 2.38432 11.2871L 2.38432 -2.83211e-06Z'
            transform='translate(79.451 16.708)'
            fill='#fff'
            id='Vector_6'
          />
          <path
            d='M 1.54751 -2.83211e-06C 1.12338 -2.83211e-06 0.756562 0.162406 0.458522 0.475615C 0.149019 0.788825 -1.3993e-06 1.16003 -1.3993e-06 1.58925C -1.3993e-06 2.04166 0.149019 2.42447 0.458522 2.73768C 0.768025 3.05089 1.13484 3.21329 1.55898 3.21329C 1.98311 3.21329 2.34993 3.05089 2.64797 2.73768C 2.95747 2.42447 3.10649 2.04166 3.10649 1.60085C 3.10649 1.16004 2.95747 0.777224 2.64797 0.475615C 2.33847 0.162406 1.97165 -2.83211e-06 1.54751 -2.83211e-06Z'
            transform='translate(79.096 10.966)'
            fill='#fff'
            id='Vector_7'
          />
        </g>
      </g>
    </svg>
  )
}
export default Logo



// WEBPACK FOOTER //
// ./src/components/icons/main-menu/Logo.tsx